import { useMemo } from 'react'

import { supportedLanguages } from '@common'

import { useLocale } from '../features/locale/useLocale'

export const useIsRTL = () => {
  const locale = useLocale()
  return useMemo(() => supportedLanguages[locale].rightToLeft, [locale])
}
